<template>
  <div class="e-bill-card">
    <div class="card-header">
      <h3 class="card-title">{{ $props.customerName }}&nbsp;{{ $props.customerLastName }}</h3>
      <div class="card-customer-id">{{ $props.customerDescription }}</div>
    </div>
    <div class="card-body">
      <div class="card-data-wrapper">
        <div class="service-type">
          <i v-if="$props.type === 'BOX'" class="icon icon-sc-box"></i>
          <i v-else-if="$props.type === 'MOBILE_POSTPAID' || $props.type === 'MOBILE_PREPAID'" class="icon icon-sc-mobile"></i>
          <i v-else-if="$props.type === 'FIXED_TELEPHONY'" class="icon icon-sc-landline"></i>
          <i v-else-if="$props.type === 'TELEVISION'" class="icon icon-sc-tv"></i>
          <i v-else-if="$props.type === 'INTERNET'" class="icon icon-sc-internet"></i>
          <h4 class="service-name">{{ $props.serviceName }}</h4></div>
        <div class="address-section">
          <span>{{ $props.deliveryAddress }}</span>
          <div class="edit-address">
            <span class="address-name">{{ $props.addressName }}</span>
            <base-button variant="text" @click="changeEmailAddress"><i class="icon-sc-edit"></i></base-button>
          </div>
        </div>
      </div>
      <base-button v-if="$props.eBillActive" variant="secondary" class="e-bill-button" @click="deactivateBillAddress">
        {{ $t('billsDelivery.deactivateEmailButton') }}
      </base-button>
      <base-button v-else variant="primary" class="e-bill-button" @click="activateBillAddress">
        {{ $t('billsDelivery.activateEmailButton') }}
      </base-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'bill-card',
  props: {
    type: String,
    customerName: String,
    customerLastName: String,
    customerDescription: String,
    serviceName: String,
    deliveryAddress: String,
    addressName: String,
    eBillActive: Boolean
  },
  methods: {
    changeEmailAddress () {
      this.$emit('change-address')
    },
    deactivateBillAddress () {
      this.$emit('deactivate-address')
    },
    activateBillAddress () {
      this.$emit('activate-address')
    }
  },
  computed: {
    iconClasses () {
      return [`icon-sc-${this.$props.icon}`]
    }
  }
}
</script>

<style scoped lang="scss" src="./bills-comp-styles/bills-delivery.scss"></style>
